import { QRCodeCanvas } from "qrcode.react";
import { useContext, useEffect, useState } from "react";
import { ConfirmationDialog } from "../../components/ConfirmationDialog";
import { appUrls } from "../../data/appUrls.data";
import { TokenDto } from "../../dtos/TokenDto";
import SaveIcon from '@mui/icons-material/Save';
import BhpLoadingButton from "../../components/BhpLoadingButton/BhpLoadingButton";
import { useManageQrCodes } from "./useManageQrCodes";
import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { Domains } from "../../data/Domains";


export const ManageQrCodes: React.FC = () => {

    const [ dialogOpen, setDialogOpen ] = useState< boolean >( false );
    const [ isLoading, setIsLoading ] = useState< boolean >( true );
    const [ isThirdParty, setIsThirdParty ] = useState< boolean >( false );
    const [ isUpdating, setIsUpdating ] = useState< boolean >( false );
    const [ tokenDtos, setTokenDtos ] = useState< TokenDto[ ] >( [ ] );
    const [ url, setUrl ] = useState< string >( '' );

    const { getTokens, updateToken } = useManageQrCodes( );

    const { domain, readonlyDomains } = useContext( VillageConsoleContext );
    

    useEffect(( ) => { initialize( ) }, [ ] );
    useEffect(( ) => { initialize( ) }, [ domain ] );


    const handleCancel = ( ) => setDialogOpen( false );
    
    
    const handleOk = () => {

        setDialogOpen( false );
        submit( );

    };


    const handleIsThirdPartyChange = async ( event: SelectChangeEvent ) => {

        const isThirdParty =  Boolean( event.target.value );
        setIsThirdParty( isThirdParty );

        const token: string = tokenDtos.find( t => t.isThirdParty === isThirdParty )?.token as string;

        setUrlByToken( token );

    };
    

    const initialize = async( ) => {

        setIsLoading( true );
        const tokenDtos: TokenDto[ ] = await getTokens( domain );
        setIsLoading( false );
        setTokenDtos( tokenDtos );
        
        let token: string;
        
        if( domain === Domains.Bma ){

            token = tokenDtos.find( t => t.isThirdParty === false )?.token as string;

        } else {

            token = tokenDtos[ 0 ].token;

        }

        setUrlByToken( token );

    };


    const setUrlByToken = ( token: string ): void => {

        const urlPrefix = appUrls.find( m => m.environment === process.env.REACT_APP_ENVIRONMENT && m.domain === domain )?.url; 
        const url = `${urlPrefix}${token}`; 
        setUrl( url );

    };


    const submit = async (): Promise<void> => {

        setIsUpdating( true );
        
        let token: string | undefined;

        if( domain === Domains.Bma ){

            token = await updateToken( domain, isThirdParty );

        } else {

            token = await updateToken( domain );

        }
        
        setIsUpdating( false );

        if ( token ) {

            setUrlByToken( token );

        } 

    };


    return (

        <>

            {
                isLoading
                    ?
                <Box
                    alignItems="center"
                    display="flex" 
                    justifyContent="center"
                    height={'100vh'}
                >
                    <CircularProgress size={40} sx={{color: '#e65400'}}/>
                </Box>
                    :
                <Stack direction="column" display="flex" justifyContent="center" alignItems="center" gap={ 2 } sx={{ marginTop: '30px' }}>

                    { 
                        domain === Domains.Bma 
                            &&
                        <FormControl sx={{ width: '400px' }}>
                            <InputLabel>Village</InputLabel>
                            <Select
                                disabled={ isUpdating }
                                onChange={ handleIsThirdPartyChange }
                                value={ isThirdParty ? "1" : "0" }
                                label="Village">
                                    <MenuItem value={ 0 }>BHP Village</MenuItem>
                                    <MenuItem value={ 1 }>Third Party Village</MenuItem>
                            </Select>
                        </FormControl>
                    }

                    <Typography>Existing QR-code:</Typography>

                    <QRCodeCanvas value={ url } size={ 400 } /> 

                    { ( !readonlyDomains.includes( domain ) ) &&
                    
                        <BhpLoadingButton
                            loading={ isUpdating }
                            loadingPosition="start"
                            onClick={( ) => setDialogOpen( true )}
                            startIcon={<SaveIcon />}
                            variant="contained"
                        >
                            Generate New QR-code
                        </BhpLoadingButton>

                    }
                </Stack>
            }

            <ConfirmationDialog 
                text={`Please confirm that you want to override the existing ${domain} QR-code`}
                dialogOpen={ dialogOpen }
                handleCancel={ handleCancel }
                handleOk={ handleOk } 
            />

        </>
    
    );
    
};